<div class="contact-content">
    <h3>SOROZAT ELEMEINEK MÓDOSÍTÁSA</h3>
    <div class="drag-and-drop-container">
        <div class="search-main-container">
            <div class="search-bar">
                <div class="search-tool">
                    <mat-icon aria-hidden="false" aria-label="keyboard_arrow_right icon" fontIcon="search" />
                    <input placeholder="Szerző, cím neve" type="search" [(ngModel)]="searchText" />
                </div>
            </div>
            <div class="title">
                <h3>{{ serie.serieName! }} csomag tartalma</h3>
            </div>
        </div>
        <div class="drag-and-drop">
            <div class="products-container">
                <div class="products">
                    @for (product of products | filter: searchText; track product) {
                        <div class="product">
                            {{ product.author + ': ' + product.title }}
                            <mat-icon (click)="addProduct(product)">add_circle_outline</mat-icon>
                        </div>
                    }
                </div>
            </div>
            <div class="title-mobile">
                <h3>{{ serie.serieName }} csomag tartalma</h3>
            </div>
            <div class="products-container">
                <div class="products">
                    @for (product of selectedBookList; track product; let i = $index) {
                        <div class="product">
                            {{ product.book?.author + ': ' + product.book?.title }} {{ i + 1 }}. rész
                            @if (i !== 0) {
                                <mat-icon (click)="decreaseSerieNumber(product)">keyboard_arrow_up</mat-icon>
                            }
                            @if (i !== selectedBookList.length - 1 || i === 0) {
                                <mat-icon (click)="increaseSerieNumber(product)">keyboard_arrow_down</mat-icon>
                            }
                            <mat-icon (click)="deleteFromSerie(product)">remove_circle_outline</mat-icon>
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>
</div>
